import clsx from 'clsx'
import { ReactNode } from 'react'

type Props = {
  className?: ReactNode
}

let InlineSkeleton = ({ className }: Props) => (
  <span
    className={clsx(
      'skeleton leading-none inline-flex items-center',
      className
    )}
  >
    &#8203;
  </span>
)

export default InlineSkeleton
